export default "__VITE_ASSET__BXyi1BJv__"